import { RestClient } from '@/api/rest-client'
import { Webhook } from '@/api/model/webhook'
import { cloneDeep } from 'lodash'
import { Company } from '@/api/model/company'
import { Branch } from '@/api/model/branch'
import { Pipeline } from '@/api/model/pipeline'
import { Source } from '@/api/model/source'

export class WebhookClient extends RestClient<Webhook> {
    collectionName = 'webhooks'
    parseData = Webhook.fromData

    async create(data: Webhook): Promise<Webhook> {
        const request = cloneDeep<any>(data)

        if (data.company instanceof Company) {
            request.company = data.company.resourceIdentifier
        }

        if (data.assignedToCompany instanceof Company) {
            request.assignedToCompany = data.assignedToCompany.resourceIdentifier
        }

        if (data.assignedToBranch instanceof Branch) {
            request.assignedToBranch = data.assignedToBranch.resourceIdentifier
        }

        if (data.pipeline instanceof Pipeline) {
            request.pipeline = data.pipeline.resourceIdentifier
        }

        if (data.newSource instanceof Source) {
            request.newSource = data.newSource.resourceIdentifier
        }

        return super.create(request)
    }

    async update(id: string, data: Webhook): Promise<Webhook> {
        const request = cloneDeep<any>(data)

        delete request.company

        if (data.assignedToCompany instanceof Company) {
            request.assignedToCompany = data.assignedToCompany.resourceIdentifier
        }

        if (data.assignedToBranch instanceof Branch) {
            request.assignedToBranch = data.assignedToBranch.resourceIdentifier
        }

        if (data.pipeline instanceof Pipeline) {
            request.pipeline = data.pipeline.resourceIdentifier
        }

        if (data.newSource instanceof Source) {
            request.newSource = data.newSource.resourceIdentifier
        }

        return super.update(id, request)
    }
}
